import styled from 'styled-components';

export const StyledNotFoundResult = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > div {
    transform: scale(1);
    width: auto !important;
    height: auto !important;
  }

  > p {
    margin-top: 16px;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 24px;
  }
`;
